import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useTranslation } from 'react-i18next';

export function StundenpensumWoche() {
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();
  const data = form.state.values;

  return (
    <>
      <span>
        {t(
          'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.stundenpensum.label',
        )}
      </span>

      <span className="text-neutrals-900 font-semibold">
        {t(
          'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.stundenpensum.options.woche',
        )}
      </span>
      <>
        <span>
          {t(
            'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.wochenstunden.label',
          )}
        </span>

        <span className="text-neutrals-900 font-semibold">
          {data.bezahlung.arbeitszeitkonto.gehaltsempfaenger.wochenstunden +
            ' ' +
            t(
              'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.wochenstunden.zusammenfassungSuffix',
            )}
        </span>
      </>
      <>
        <span>
          {t(
            'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.unbezahlteUeberstundenWoche.label',
          )}
        </span>

        <span className="text-neutrals-900 font-semibold">
          <span>
            {data.bezahlung.arbeitszeitkonto.gehaltsempfaenger
              .unbezahlteUeberstundenWoche ?? '00:00'}
          </span>
          <span>
            {` ${t(
              'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.unbezahlteUeberstundenWoche.zusammenfassungSuffix',
            )}`}
          </span>
        </span>
      </>
    </>
  );
}
